import { SVGProps } from 'react';

const SvgCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 17 13" {...props}>
    <path stroke="#28C156" strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="m1 6.5 5 5 10-10" />
  </svg>
);

export default SvgCheck;
